import constants from '@/constants'

export default {
  methods: {
    getSnsIconDefaultAttrs (snsName) {
      let defaultAttrs
      switch (snsName) {
        case 'X':
          defaultAttrs = JSON.parse(JSON.stringify(constants.xIcon))
          break
        case 'Facebook':
          defaultAttrs = JSON.parse(JSON.stringify(constants.facebookIcon))
          break
        case 'YouTube':
          defaultAttrs = JSON.parse(JSON.stringify(constants.youtubeIcon))
          break
        case 'Instagram':
          defaultAttrs = JSON.parse(JSON.stringify(constants.instagramIcon))
          break
        case 'LINE':
          defaultAttrs = JSON.parse(JSON.stringify(constants.lineIcon))
          break
        case 'Email':
          defaultAttrs = JSON.parse(JSON.stringify(constants.emailIcon))
          break
        case 'Website':
          defaultAttrs = JSON.parse(JSON.stringify(constants.websiteIcon))
          break
        case 'Tel':
          defaultAttrs = JSON.parse(JSON.stringify(constants.telIcon))
          break
        default:
          defaultAttrs = null
      }
      return defaultAttrs
    }
  }
}
